import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  formData: {},
  currentStep: 0,
  stepValidity: {},
  onboardingCompleted: false,
  fullOnboardingProgress: 0,
};

const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    updateFormData: (state, action) => {
        state.formData = {
            ...state.formData,
            ...action.payload,
        };
    },
    setStepValidity: (state, action) => {
      const { stepIndex, isValid } = action.payload;
      if (typeof stepIndex !== 'number') return;

      // Only update if validity actually changed
      if (state.stepValidity[stepIndex] !== isValid) {
        state.stepValidity = {
          ...state.stepValidity,
          [stepIndex]: isValid,
        };
      }
    },
    setCurrentStep: (state, action) => {
      const newStep = action.payload;
      if (typeof newStep === 'number' && newStep >= 0 && newStep < 5) {
        // Step upper bound is arbitrary—adjust if you have a known max
        state.currentStep = newStep;
      }
    },
    setOnboardingCompleted: (state, action) => {
      state.onboardingCompleted = Boolean(action.payload);
    },
    setFullOnboardingProgress: (state, action) => {
      const progress = Number(action.payload);
      state.fullOnboardingProgress = Math.max(0, Math.min(100, progress));
    },
    resetOnboarding: () => ({
      ...initialState,
    }),
    loadFromLocalStorage: (state, action) => {
        const { formData, currentStep, stepValidity } = action.payload;
        state.formData = formData && typeof formData === 'object' ? { ...formData } : {};
        state.currentStep = typeof currentStep === 'number' && currentStep >= 0 ? currentStep : 0;
        state.stepValidity = stepValidity && typeof stepValidity === 'object' ? { ...stepValidity } : {};
    },
  },
});

export const {
  updateFormData,
  setStepValidity,
  setCurrentStep,
  setOnboardingCompleted,
  setFullOnboardingProgress,
  resetOnboarding,
  loadFromLocalStorage,
} = onboardingSlice.actions;

export default onboardingSlice.reducer;
